import { FormContextActions } from './form-context-actions.type';

export const formContextReducer = <FS extends {} = any>(
  state: FS,
  action: FormContextActions<FS>
): FS => {
  switch (action.type) {
    case 'OverrideState': {
      return { ...action.payload };
    }
    case 'FormChangeByInputName': {
      const fieldPath = action.inputName.split('.');
      const fieldName = fieldPath.pop();
      if (!fieldName) {
        return state;
      }
      if (fieldPath.length === 0) {
        return {
          ...state,
          [fieldName]: action.payload
        };
      }

      const searchAndUpdate = (fieldPath: string[], stateMap: Record<string, unknown>): void => {
        if (fieldPath.length === 0) {
          stateMap[fieldName] = action.payload;
          return;
        }
        const sectionName = fieldPath[0];
        const newPath = fieldPath.slice(1, fieldPath.length);
        if (
          !stateMap.hasOwnProperty(sectionName) ||
          stateMap[sectionName] == null ||
          typeof stateMap[sectionName] != 'object'
        ) {
          stateMap[sectionName] = {};
        }
        searchAndUpdate(newPath, stateMap[sectionName] as Record<string, unknown>);
      };

      const newState = { ...state };
      searchAndUpdate(fieldPath, newState);
      return newState;
    }
    default: {
      return state;
    }
  }
};
